import { useEffect, useState } from 'react';

/**
 * Drives the sticky Expand-all / Collapse-all button label on a collapsible list section.
 *
 * The label flips ONLY at the two boundaries — every item expanded → "Collapse all"; every item
 * collapsed → "Expand all". Partial states in between preserve whichever label was last set, so
 * a user who expanded everything and then collapses one item still sees "Collapse all" until all
 * items are collapsed.
 */
export const useStickyExpandAllLabel = (
  items: { id: string }[],
  expandedIds: Set<string>,
): boolean => {
  const [showsCollapseAll, setShowsCollapseAll] = useState(false);

  useEffect(() => {
    if (items.length === 0) return;
    if (items.every((item) => expandedIds.has(item.id))) {
      setShowsCollapseAll(true);
    } else if (items.every((item) => !expandedIds.has(item.id))) {
      setShowsCollapseAll(false);
    }
  }, [items, expandedIds]);

  return showsCollapseAll;
};
